import { useEffect, useRef } from 'react';

interface PollingOptions {
  initialInterval?: number;
  maxInterval?: number;
  enabled?: boolean;
}

const defaultPollingOptions: PollingOptions = {
  initialInterval: 2000,
  maxInterval: 15000,
  enabled: true,
};

export default function usePolling(
  fetchCallback: () => void,
  options: PollingOptions = {}
) {
  const { initialInterval, maxInterval, enabled } = { ...defaultPollingOptions, ...options };
  const pollingInterval = (initialInterval ?? 2000) > (maxInterval ?? 15000) ? maxInterval : initialInterval;
  
  const savedCallback = useRef(fetchCallback);

  useEffect(() => {
    savedCallback.current = fetchCallback;
  }, [fetchCallback]);

  useEffect(() => {
    if (!enabled) return;

    // Initial fetch
    savedCallback.current();

    const intervalId = setInterval(() => {
      if (document.visibilityState === 'visible') {
        savedCallback.current();
      }
    }, pollingInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, [pollingInterval, enabled]);
}
